import React, { useEffect, useState } from "react";
import Header from "./components/header";
import LandingScreen from "./components/landingScreen";
import { Route, Routes, useNavigate } from "react-router-dom";
import Contact from "./components/contactScreen";
import { Projects } from "./components/projects";
import { Project } from "./pages/project";
import { StatusModal } from "./components/statusModal";

const Router = () => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);

  const Callback = () => {
    useEffect(() => {
      navigate("/home");
    });
    return null;
  };

  const routes = [
    { path: "/home", element: <LandingScreen /> },
    { path: "/about", element: <LandingScreen /> },
    { path: "*", element: <Callback /> },
    { path: "/contact", element: <Contact /> },
    { path: "/projects", element: <Projects /> },
    { path: "/project/:name", element: <Project /> },
  ];
  return (
    <>
      <StatusModal show={show} setShow={setShow} />
      <Header setAppear={setShow} />
      <Routes>
        {routes.map((route, index) => {
          return (
            <Route key={index} path={route?.path} element={route?.element} />
          );
        })}
      </Routes>
    </>
  );
};

export default Router;
